import _ from 'lodash';

var ymapsRequire = (function () {
  try {
    return require('../../../../serp/helpers/ymaps-reqiure.js');
  } catch (err) {
    return ymaps.modules.require.bind(ymaps.modules);
  }
}());

angular.module('cian.geoService')
  .factory('GeoSuggest', [
    "$q",
    "$log",
    "GeoApi",
    "GeoUtils",
    "HighwaysService",
    "RegionUtilsService",
    function ($q, $log, GeoApi, GeoUtils, HighwaysService, RegionUtilsService) {

    const MAX_RESULTS = 7;

    /**
     * Область на карте, результаты из которой будут идти в начале списка саджестов.
     * Формат: координаты (долгота, широта) нижнего левого угла и верхнего правого.
     * @type {?Array.<number[]>}
     * @example
     * [[30, 40], [50, 50]]
     */
    let boundBox;

    /**
     * Определяем границы области для приоритезации саджестом
     * Для групп (например, Москва+МО) берём границы области
     * @param {Region[]} regions
     */
    function setBoundBox(regions) {
      const searchBounds = _.last(regions).bounded_by;

      boundBox = searchBounds && [[
          searchBounds.lowerCorner.lng,
          searchBounds.lowerCorner.lat,
        ], [
          searchBounds.upperCorner.lng,
          searchBounds.upperCorner.lat,
        ]];
    }

    /**
     * @param {string} query
     * @param {Region} region
     */
    function getNewBuildingSuggestions(query, region) {
      var def = $q.defer();

      GeoApi.newBuildingSuggest(query, region.id)
        .success(function(newBuildingSuggestions) {
          let response = {};

          response.newobjects = _.map(_.filter(newBuildingSuggestions.suggestions, function(newBuildingSuggestion) {
            return newBuildingSuggestion.data.Type === 1;
          }), function(newBuildingSuggestion) {
            var newBuildingData = newBuildingSuggestion.data;
            return {
              label: newBuildingData.Name,
              value: newBuildingData.Value,
              desc: newBuildingData.Address,
              url: newBuildingData.Url,
              data: {
                type: 'newobject',
                id: newBuildingData.Id,
                text: newBuildingData.Name,
                regionId: newBuildingData.LocationId
              }
            };
          });
          response.builders = _.map(_.filter(newBuildingSuggestions.suggestions, function(newBuildingSuggestion) {
            return newBuildingSuggestion.data.Type === 6;
          }), function(newBuildingSuggestion) {
            var newBuildingData = newBuildingSuggestion.data;
            return {
              label: newBuildingData.Name,
              value: newBuildingData.Value,
              data: {
                type: 'builder',
                id: newBuildingData.Id,
                text: newBuildingData.Name
              }
            };
          });

          def.resolve(response);
        })
        .error(function () {
          def.reject('Unable to get new buildings suggestions');
        });

      return def.promise;
    }

    /**
     * source: cian/static/search/scripts/geo/geo.GeoService.js
     * @param {string} query
     * @param {Region} region
     */
    function getBCSuggetions (query, region) {
      const def = $q.defer();

      if (isQueryIncludesBC(query)) {
        query = query.trim().substring(2);
      }

      GeoApi.BCSuggest(query, region.id)
        .success(res => {
          def.resolve(res.data.bsCenters.map(
            bc => ({
              type: 'bs_center',
              label: bc.name,
              text: bc.name,
              id: bc.id,
            })
          ));
        })
        .error(() => {
          def.reject('Unable to get commercial buildings suggestions');
        });

      return def.promise;
    }

    /**
     * @param {string} query
     */
    function getYandexSuggestions(query) {
      var def = $q.defer();

      ymapsRequire('suggest', function (ymapsSuggest) {
        ymapsSuggest(GeoUtils.getCountry() + ', ' + query, {
          results: MAX_RESULTS,
          boundedBy: boundBox,
        })
          .then(function (items) {
            def.resolve(_.map(items, function (obj) {
              return {
                label: GeoUtils.removeCountryFromAddress(obj.displayName),
                value: GeoUtils.removeCountryFromAddress(obj.value),
              };
            }));
          }).catch(function (error) {
            $log.error(error);
          });
      });

      return def.promise;
    }

    /**
     * @param def
     * @param {string} query
     */
    function regularSuggestion(def, query) {
      getYandexSuggestions(query)
        .then(dataYandexSuggestions => def.resolve(dataYandexSuggestions));
    }

    /**
     * @param def
     * @param {string} query
     * @param {Region} region
     * @param {object} options
     */
    function suggestWithNewBuildings(def, query, region, options) {
      const hasToSearchNewBuilding = query.toLowerCase().indexOf('жк') === 0;

      getNewBuildingSuggestions(query, region)
        .then(
          newBuildingsData => {
            if (hasToSearchNewBuilding && newBuildingsData.newobjects.length) {
              def.resolve(newBuildingsData.newobjects);
            } else {
              getYandexSuggestions(query)
                .then(function(dataYandexSuggestions) {
                  let suggestions = [];

                  const isGrouped = _.filter([dataYandexSuggestions, newBuildingsData.newobjects, newBuildingsData.builders], function(suggestion) {
                    return suggestion.length > 0;
                  }).length > 1;

                  let addresses = dataYandexSuggestions.slice(0, 4);
                  for (let i = 0; i < addresses.length; i++) {
                    let address = addresses[i];
                    if (i === 0 && isGrouped) {
                      address.group = 'Адреса';
                    }
                    suggestions.push(address);
                  }

                  let newobjects = newBuildingsData.newobjects.slice(0, 4);
                  for (let i = 0; i < newobjects.length; i++) {
                    let newobject = newobjects[i];
                    if (i === 0 && isGrouped) {
                      newobject.group = 'Жилые комплексы';
                    }
                    suggestions.push(newobject);
                  }

                  let builders = newBuildingsData.builders.slice(0, 4);
                  for (let i = 0; i < builders.length; i++) {
                    let builder = builders[i];
                    if (i === 0 && isGrouped) {
                      builder.group = 'Застройщики';
                    }
                    suggestions.push(builder);
                  }

                  def.resolve(suggestions);
                });
            }
          },
          () => regularSuggestion(def, query)
        );
    }

    /**
     * @param def
     * @param {string} query
     * @param {Region} region
     */
    function suggestWithHighways(def, query, region) {
      HighwaysService.getHighways(region.id)
        .then(
          data => {
            // Отсеиваем шоссе только по названию (чтобы работал поиск по "Шоссе Киевское")
            const highwayQuery = _.trimStart(query.toLowerCase().replace('шоссе', ''));
            let highways = _.reduce(data, (res, dir) => res.concat(dir.highways), [])
              .map(h => ({
                ...h,
                label: `${h.text} шоссе`,
              }))
              // Фильтруем по названию
              .filter(h => h.label.toLowerCase().includes(highwayQuery))
              .slice(0, 3);

            getYandexSuggestions(query)
              .then(dataYandexSuggestions => {
                const suggestions = _.uniqBy(
                  highways.concat(dataYandexSuggestions), 'label'
                );
                def.resolve(_.take(suggestions, MAX_RESULTS));
              });
          },
          () => regularSuggestion(def, query)
        );
    }

    /**
     * @param def
     * @param {string} query
     * @param {Region} region
     */
    function suggestWithBC(def, query, region) {
      getBCSuggetions(query, region)
        .then(
          dataBC => {
            getYandexSuggestions(query)
              .then(dataYandexSuggestions => {
                def.resolve(dataBC.slice(0, 3).concat(dataYandexSuggestions));
              });
          },
          () => regularSuggestion(def, query)
        );
    }

    /**
     * @param {string} query
     * @return {boolean}
     */
    function isQueryIncludesBC(query) {
      return query.toLowerCase().indexOf('бц ') === 0;
    }


    /**
     * @param {string} query
     * @param {Region[]} currentRegions
     * @param {object} options
     * @param {boolean} options.suggestNewBuildings
     * @param {boolean} options.suggestHighways
     * @param {boolean} options.suggestBC
     * @return {Promise}
     */
    function suggest(query, currentRegions, options) {
      const def = $q.defer();

      setBoundBox(currentRegions);

      const shouldSuggestBc = options.suggestBC && (
          query.length >= 3 || isQueryIncludesBC(query)
        );

      const searchRegion = currentRegions[0];


      if (options.suggestNewBuildings) {
        suggestWithNewBuildings(def, query.trim(), searchRegion, options);
      } else if (options.suggestHighways) {
        suggestWithHighways(def, query.trim(), RegionUtilsService.findRegionWithHighway(currentRegions));
      } else if (shouldSuggestBc) {
        suggestWithBC(def, query, searchRegion);
      } else {
        regularSuggestion(def, query.trim());
      }

      return def.promise;
    }

    return {
      suggest: suggest
    };
  }]);



// WEBPACK FOOTER //
// ./src/components/geo-service/src/scripts/cian.geoSuggest.js